var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":_vm.title,"width":"1100px","in-dialog":_vm.inDialog}},[_c('list',{ref:"list"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }